import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HelpModel } from '../models/help.model';
import { ApiService } from '../../core/services/api.service';
import { WordMark } from '../models/shared.inerface';

@Injectable({
    providedIn: 'root',
})
export class WordMarkService {

    constructor(private apiService: ApiService, private http: HttpClient) { }

    getData() {
        return this.apiService.createGetServiceCall<WordMark[]>
            (
                this.apiService.getBaseUrl() + 'word-mark/',
                ''
            );

    }

    getHelp(): HelpModel[] {
        return [
            {
                label: 'Manage Word Marks',
                content:
                    'The Manage Word Marks interface shows all word marks that have been uploaded into the HS Forms application. Word marks that have a status of ‘Active’ are available for use; word marks that are ‘Inactive’ are not available for use on future forms. Note: All ‘Active’ uploaded word marks are globally available. The maximum file size is 20 MB and only files with the file extension of .GIF, .JPEG, .JPG, and .PNG can be uploaded.',
            },
        ];
    }
}

